// import { CloseOutlined, Search } from '@material-ui/icons';
import { CloseOutlined, Search } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Autocomplete,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { useConfirm } from 'material-ui-confirm';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { usaStateListWithCodes } from '../../data/fhirHumanNameData';
import AxiosInstance, {
  ehrAPIBaseService,
  ehrAPIService,
} from '../../http-common';
import FormError from '../form/FormErrors';
import {
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_RIGHT_DRAWER_NOT,
} from '../MainUIFrame/constants';
import { useMainFrameDispatch } from '../MainUIFrame/MainFrame';
import CreatePractitionerDialog from './CreatePractitionerDialog';
import { isEmpty, isUndefined } from 'lodash';
import { generateNotifications } from '../reusableLogic';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

const NPIRegistryDrawer = props => {
  const dispatch = useMainFrameDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const reduxDispatch = useDispatch();
  const confirmation = useConfirm();
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const [npiTypeState, setNpiTypeState] = useState(`NPI-1`);
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    reset();
    setFormKey(prevKey => prevKey + 1);
    setNPIRegistries([]);
  }, [npiTypeState]);

  useEffect(() => {
    if (props?.npiType) {
      setNpiTypeState(props?.npiType);
    }
  }, [props?.npiType]);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [NPIRegistries, setNPIRegistries] = useState([]);
  const [practitionerCheckLoading, setPractitionerCheckLoading] = useState({
    loading: false,
    message: '',
  });
  const [practitionerDialog, setPractitionerDialog] = useState({
    open: false,
    data: {},
  });
  const [hasCreatePractitioner] = useState(
    props?.hasOwnProperty('showCreatePractitioner')
      ? props?.showCreatePractitioner
      : false
  );
  const [usaCodes] = useState(
    usaStateListWithCodes.map(m => {
      return {
        label: m.code,
        value: m.code,
      };
    })
  );

  const handleClose = () => {
    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    dispatch({ type: ACTION_RIGHT_DRAWER_JSX, payload: <></> });
  };

  const searchNPI = async data => {
    setErrorMessage('');
    setNPIRegistries({
      results_count: 0,
      results: [],
      isSearched: false,
    });
    if (
      Object.keys(data)
        .filter(f => f !== 'state')
        .every(s => !data[s])
    ) {
      if (data.state) {
        setErrorMessage(
          'A search by state can be very large. Narrow your search further.'
        );
      } else {
        setErrorMessage('Type something to search. Try a name or location.');
      }
      return false;
    }
    try {
      setLoading(true);
      let url = `npi?version=2.1&limit=20&exactMatch=true&enumeration_type=${npiTypeState}`;
      //   let elementsToRemove = [
      //     "state",
      //     "first_name",
      //     "last_name",
      //     "organization_name",
      //   ];
      Object.keys(data)
        .filter(f =>
          npiTypeState === 'NPI-1'
            ? f !== 'organization_name'
            : !['first_name', 'last_name'].includes(f)
        )
        .filter(f => !isEmpty(data[f]))
        .forEach(f => {
          url += `&${f}=${data[f]?.value || data[f]}`;
        });
      //   Object.keys(data)
      //     .filter((f) => f !== "state")
      //     .forEach((f) => {
      //       url += `&${f}=${data[f]}`;
      //     });
      //   if (data["state"]?.value) url += `&state=${data["state"]?.value}`;
      //   if (data["first_name"]?.value)
      //     url += `&first_name=${data["first_name"]?.value}`;
      //   if (data["last_name"]?.value)
      //     url += `&last_name=${data["last_name"]?.value}`;
      //   if (data["organization_name"]?.value)
      //     url += `&organization_name=${data["organization_name"]?.value}`;

      let response = await ehrAPIBaseService.get(url);
      if (response?.status === 200) {
        setNPIRegistries({
          ...response?.data,
          isSearched: true,
        });
      }
    } catch (e) {
      setErrorMessage('Something went wrong, please search again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => handleClose;
  }, []);

  const getPrimaryDataFormat = (addresses, type = 'address') => {
    if (!addresses.length) return '-';
    if (type === 'address') {
      return `${addresses[0].address_1} ${addresses[0].city} ${addresses[0].state} ${addresses[0].postal_code}`;
    } else if (type === 'phone') {
      // return `${addresses[0].telephone_number}`;
      if (addresses[0]?.telephone_number) {
        return `${addresses[0].telephone_number}`;
      } else if (addresses[1].telephone_number) {
        return `${addresses[1].telephone_number}`;
      } else {
        return `-`;
      }
    }
  };

  const getPrimaryTaxonomy = taxonomies => {
    if (!taxonomies.length || !taxonomies.some(s => s.primary)) return '-';
    return `${taxonomies.find(f => f.primary)?.desc}`;
  };

  const getPractitionerAddressObjects = addresses => {
    return addresses.map(address => {
      return {
        city: address?.city,
        country: address?.country_code === 'US' ? 'USA' : address?.country_code,
        line: [address?.address_1 || '', address?.address_2 || ''],
        postalCode: address?.postal_code.substr(0, 5),
        state: address?.state,
        type: address?.address_type === 'DOM' ? 'postal' : 'physical',
        use: address?.address_purpose === 'LOCATION' ? 'work' : 'home',
      };
    });
  };

  const copyToForm = async npiDetails => {
    // confirmation({
    //   description: `This action will copy this NPI (${npiDetails?.number}) details to the form, and all previous form data will be overwritten. Are you sure want to proceed?`,
    // }).then(() => {
    if (props.hasOwnProperty('fromUser') && props?.fromUser) {
      setPractitionerCheckLoading({
        loading: npiDetails?.number,
        message: 'Checking availability...',
      });
      try {
        let url = `fhir/search/?resourceType=Practitioner&identifier=${npiDetails?.number}`;
        let response = await ehrAPIBaseService(url);
        if (response?.status === 200) {
          if (response?.data?.total === 0) {
            // props.hasOwnProperty('setPractitionerSelectedFromLocal') &&
            //   props.setPractitionerSelectedFromLocal({
            //     isSelected: true,
            //     data: response?.data?.entry?.[0]?.resource,
            //   });
            typeof props?.setNPIUserForm === 'function' &&
              props?.setNPIUserForm({
                isSelected: true,
                data: npiDetails,
              });
          } else {
            alert('Record already created');
          }
          handleClose();
          return false;
        }
      } catch (err) {
        console.log('Error in NPIRegistryDrawer.jsx -> ', err);
      }
    }
    props?.setNPI({
      isSelected: true,
      data: npiDetails,
    });

    if (isUndefined(props?.disableCloseButton)) {
      handleClose();
    }
    // });
  };

  const getGender = gender => {
    if (gender.toLowerCase() === 'm') {
      return 'male';
    } else if (gender.toLowerCase() === 'f') {
      return 'female';
    } else if (gender.toLowerCase() === 'o') {
      return 'other';
    } else {
      return 'unknown';
    }
  };

  const showPractitionerCreate = async npi => {
    setPractitionerCheckLoading({
      loading: npi?.number,
      message: 'Checking availability...',
    });
    try {
      let url = `fhir/search/?resourceType=Practitioner&identifier=${npi?.number}`;
      let response = await ehrAPIBaseService(url);
      if (response?.status === 200) {
        if (response?.data?.total) {
          copyToForm(npi);
        } else {
          setPractitionerCheckLoading({
            loading: npi?.number,
            message: 'Creating practitioner...',
          });
          let identifierNPIObj = {
            use: 'usual',
            type: {
              coding: [
                {
                  system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                  code: 'NPI',
                  userSelected: false,
                },
              ],
            },
            system: 'http://hl7.org/fhir/sid/us-ssn',
            value: npi?.number,
          };
          let telecom = [
            {
              system: 'phone',
              use: 'home',
              value: getPrimaryDataFormat(npi?.addresses, 'phone').replaceAll(
                '-',
                ''
              ),
            },
          ];
          debugger;
          let payload = {
            active: true,
            address: getPractitionerAddressObjects(npi?.addresses),
            name: [
              {
                family: npi?.basic?.last_name,
                given: [
                  npi?.basic?.first_name,
                  npi?.basic?.middle_name || '',
                  npi?.basic?.last_name,
                ],
                prefix: [npi?.basic?.name_prefix],
                suffix: [
                  npi?.basic?.name_suffix === '--'
                    ? ''
                    : npi?.basic?.name_suffix,
                ],
                text: `${npi?.basic?.first_name} ${
                  npi?.basic?.middle_name || ''
                } ${npi?.basic?.last_name}`,
                use: 'official',
              },
            ],
            gender: getGender(npi?.basic?.gender),
            resourceType: 'Practitioner',
            identifier: [identifierNPIObj],
            telecom,
          };
          let response = await ehrAPIService.post(`createResource`, payload);
          if ([200, 201].includes(response?.status)) {
            props?.setNPI({
              isSelected: true,
              data: npi,
            });
            handleClose();
          } else {
            const display =
              'Something went wrong while creating the practitioner.';
            generateNotifications({
              title: display,
              descriptions: display,
              enqueueSnackbar,
              closeSnackbar,
              reduxDispatch,
            });
          }
        }
      }
    } catch (e) {
      const display = 'Something went wrong, please try again.';
      generateNotifications({
        title: display,
        descriptions: display,
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
    } finally {
      setPractitionerCheckLoading({
        loading: false,
        message: '',
      });
    }
  };

  return (
    <>
      <Grid container style={{ marginTop: '1em' }}>
        <Grid item xs={10}>
          {isUndefined(props?.disableCloseButton) ||
            (props?.header && (
              <Typography align="center" noWrap variant="h6">
                Search NPI Registry
              </Typography>
            ))}
          <br />
        </Grid>
        <Grid item xs={2}>
          {isUndefined(props?.disableCloseButton) && (
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(searchNPI)} key={formKey}>
        <Grid
          container
          columnSpacing={1}
          rowSpacing={1}
          style={{ padding: '0 5px' }}
        >
          <Grid item xs={12}>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              type="number"
              label="NPI"
              {...register('number', {
                maxLength: 10,
                minLength: 10,
              })}
              fullWidth
            />
            {errors?.number && <FormError msg={errors.number} />}
          </Grid>

          {npiTypeState === 'NPI-1' ? (
            <>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  label="First Name"
                  {...register('first_name')}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  label="Last Name"
                  {...register('last_name')}
                  fullWidth
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item sm={12}>
                <TextField
                  size="small"
                  label="Organization Name"
                  {...register('organization_name')}
                  fullWidth
                />
              </Grid>
            </>
          )}

          <Grid item xs={6}>
            <TextField
              size="small"
              label="City"
              {...register('city')}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Controller
              name={'state'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  size="small"
                  disablePortal={true}
                  options={usaCodes}
                  onChange={(e, value) => {
                    onChange(value);
                  }}
                  value={value}
                  fullWidth
                  renderInput={params => (
                    <TextField {...params} label="State" />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              size="small"
              type="submit"
              fullWidth
              loading={loading}
              loadingPosition="start"
              startIcon={<Search />}
              variant="contained"
            >
              <span>Search</span>
            </LoadingButton>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                if (props?.handleQuickAddClose) {
                  props?.handleQuickAddClose();
                } else {
                  dispatch({
                    type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
                  });
                }
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </form>
      <Grid
        container
        rowSpacing={1}
        style={{ marginTop: '1em', padding: '0 5px 10px 5px' }}
      >
        <Grid item xs={12}>
          {NPIRegistries?.isSearched ? (
            <Alert
              severity={NPIRegistries?.result_count ? 'success' : 'warning'}
            >{`${
              NPIRegistries?.result_count ? NPIRegistries?.result_count : '0'
            } records found${
              NPIRegistries?.result_count === 20
                ? ', to narrow your search results, please modify your search criteria.'
                : ''
            }`}</Alert>
          ) : null}
        </Grid>
        {NPIRegistries?.results?.map((npi, idx) => {
          return (
            <Grid item xs={12} key={`npi_card_${idx + 1}`}>
              <Card sx={{ maxWidth: 345 }}>
                <CardContent>
                  <p className="b-700 fs-lg">
                    {npiTypeState === 'NPI-1'
                      ? `${
                          !npi?.basic?.name_prefix ||
                          npi?.basic?.name_prefix === '--'
                            ? ''
                            : npi?.basic?.name_prefix
                        } ${npi?.basic?.first_name} ${npi?.basic?.last_name}`
                      : `${npi?.basic?.organization_name}`}
                  </p>
                  <Typography variant="body2" color="text.secondary">
                    <ul>
                      <li>
                        <b>NPI:</b> {npi?.number}
                      </li>
                      <li>
                        <b>Primary Practice Address:</b>{' '}
                        {getPrimaryDataFormat(npi?.addresses, 'address')}
                      </li>
                      <li>
                        <b>Phone:</b>{' '}
                        {getPrimaryDataFormat(npi?.addresses, 'phone')}
                      </li>
                      <li>
                        <b>Primary Taxonomy:</b>{' '}
                        {getPrimaryTaxonomy(npi?.taxonomies)}
                      </li>
                    </ul>
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() =>
                      hasCreatePractitioner
                        ? showPractitionerCreate(npi)
                        : copyToForm(npi)
                    }
                    disabled={practitionerCheckLoading?.loading === npi?.number}
                  >
                    {practitionerCheckLoading?.loading === npi?.number ? (
                      <>
                        <span style={{ padding: '7px 12px' }}>
                          <CircularProgress size="1rem" />
                        </span>
                        {practitionerCheckLoading?.message}
                      </>
                    ) : (
                      'Copy to form'
                    )}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      {(practitionerDialog?.open && (
        <CreatePractitionerDialog
          dialog={practitionerDialog}
          setDialog={setPractitionerDialog}
        />
      )) ||
        null}
    </>
  );
};

export default NPIRegistryDrawer;
